export const LSK_SIDEBAR_VISIBILITY = 'tt_sidebar_visibility';

/**
 * Used to store the booker email and prefill the form.
 */
export const LSK_BOOKER_EMAIL = 'tt_booker_email';
